import { detectBrowser } from "./DriveUtils";
/**
 * Drive IE compatibility has been removed , hence now can open drive with driver invokation with windows dll
 * example : {Drive full URL/bin/start/wsStart.application}/?ID_TOKEN=${driveToken}
 */

// const dmsProxyDNS = 'dms.drive.connectcdk.com';
const dmsProxyDNS = 'dms.drive.connectcdk.com/bin/start/wsStart.application';
export const CUSTOM_PORTAL = 'cdkdrive';


type MakeDMSProxyFirewallUrl = {
  cNumber: string | string[];
  driveToken: string;
  lang:string;
};

type ReturnUseDMSProxyUrl = {
  url: string;
  cNumber: string;
  driveToken: string;
};

export const getDMSProxyFirewallUrl = ({
  cNumber = '',
  driveToken = '',
  lang = 'en_US'
}: Partial<MakeDMSProxyFirewallUrl>): ReturnUseDMSProxyUrl => {
  const joinedCNumber = Array.isArray(cNumber) ? cNumber.join(',') : cNumber;
  const url = `https://${joinedCNumber}-${dmsProxyDNS}?ID_TOKEN=${driveToken}&BROWSER=${detectBrowser()}&LANG=${lang}`;
  return { url, cNumber: joinedCNumber,driveToken};
};

export const getDMSProxyFirewallUrlEncrypted = ({
  cNumber = '',
  driveToken = ''
}: Partial<MakeDMSProxyFirewallUrl>): ReturnUseDMSProxyUrl => {
  const joinedCNumber = Array.isArray(cNumber) ? cNumber.join(',') : cNumber;
  const url = `https://${joinedCNumber}-${dmsProxyDNS}?PARAMS=${driveToken}`;

  return {url,cNumber: joinedCNumber,driveToken};
};
